module.exports = __webpack_public_path__ + "img/ef1.a36f66a3.jpg";